const port = process.env.BACKEND_PORT || 3000
const localURL = `http://0.0.0.0:${port}`
const SERVER = window.location.hostname === '0.0.0.0' || window.location.hostname === 'localhost'

export const CURRENT_SERVER = SERVER
  ? `${localURL}/apiemail/`
  : `${window.location.protocol}//${window.location.hostname}/apiemail/`

export const FINANCE_SERVER = SERVER
  ? 'http://0.0.0.0:3000/api/'
  : `${window.location.protocol}//${window.location.hostname}/api/`

export const SOCKET_EMAIL = SERVER
  ? localURL
  : `${window.location.protocol}//${window.location.hostname}`



// WEBPACK FOOTER //
// ./src/constants/domains.js